import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import {ConstantsService} from "../../services/constants/constants.service";


@Component({
  selector: 'app-search',
  templateUrl: './search.component.pug',
  styleUrls: ['./search.component.scss'],
  standalone: false
})
export class SearchComponent implements OnInit {
  @Input() options:any[] = [];
  @Input() defaultCol = '';
  @Output() searchChange = new EventEmitter();
  onfocus = false;
  selectedColumns = new Map();
  selected = new Map();
  labelValue: any = {};
  searchValue = '';
  @ViewChild('searchwithoptions') searchWithOptions: any;
  @ViewChild('dropdown') searchOption: any;

  constructor() {
    this.onSearch = _.debounce(this.onSearch, ConstantsService.DEBOUNCE_RATE);
  }

  ngOnInit(): void {
    if( this.options.length != 0 && this.defaultCol == '') {
      this.defaultCol = this.options[0].value;
    }
  }

  selectColumn(col) {
    if (this.selectedColumns.has(col.label)) {
      this.selectedColumns.delete(col.label);
    } else {
      this.selectedColumns.set(col.label, col);
      this.onfocus = true;
      this.searchWithOptions.nativeElement.focus();
    }
    if (!this.selectedColumns.size){
      this.onfocus = false;
      this.searchWithOptions.nativeElement.blur();
    }
    if (this.searchValue=='') {
      this.searchChange.emit(undefined);
      return false;
    }
    let cols = Array.from(this.selectedColumns, ([key,value])=>(value.value));
    this.searchChange.emit({
      'value': this.searchValue,
      'columns': cols.length != 0 ? cols : [this.defaultCol],
    });
    return false;
  }

  onSearch(event){
    this.searchValue = event.target.value;
    if (this.searchValue=='') {
      return this.searchChange.emit(undefined)
    }
    if (event.which == 13) {
      this.searchOption.hide();
      this.onfocus = false;
      this.searchWithOptions.nativeElement.blur();
    }
    let cols = Array.from(this.selectedColumns, ([key,value])=>(value.value));
    this.searchChange.emit({
      'value': this.searchValue,
      'columns': cols.length != 0 ? cols : [this.defaultCol],
    });
  }


}
